var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.393 20a.447.447 0 01-.312-.13l-4.972-4.843H.469c-.26 0-.469-.229-.469-.512V.512C0 .23.21 0 .469 0H19.53c.26 0 .469.23.469.512v14.003c0 .283-.21.512-.469.512H14.91l-.047 4.468c-.003.28-.212.505-.469.505zM5 4.372a1 1 0 00-1 1v.185a1 1 0 001 1h10a1 1 0 001-1v-.185a1 1 0 00-1-1H5zm0 4.371a1 1 0 00-1 1v.186a1 1 0 001 1h4a1 1 0 001-1v-.186a1 1 0 00-1-1H5z"
  })));
}
export default SvgNews;